var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrowAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-240v-368L296-464l-56-56 240-240 240 240-56 56-144-144v368h-80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowAsc);
export default __webpack_public_path__ + "static/media/SortArrowAsc.fb381de13e51679f66514e0a72089626.svg";
export { ForwardRef as ReactComponent };